<template>
    <div>
        <div class="c-card u-p-small">

            <div class="row u-mt-small">
                <div class="col-4 d-none">
                    <div class="c-field">
                        <label class="c-field__label">Vendor</label>
                        <v-select :value="vendors[0]" :clearable="false" :searchable="false" @update:model-value="vendorChanged" :options="vendors"></v-select>
                    </div>
                </div>

                <div class="col-4">
                    <div class="c-field">
                        <label class="c-field__label">Country</label>
                        <v-select :value="countries[0]" :clearable="false" :searchable="false" @update:model-value="countryChanged" :options="countries"></v-select>
                    </div>
                </div>
            </div>

            <div class="row u-mt-small">
                <div class="col-4">
                    <div class="c-field">
                        <label class="c-field__label">Search By</label>
                        <v-select :value="searchByOptions[0]" :clearable="false" :searchable="false" @update:model-value="searchByChanged" :options="searchByOptions"></v-select>
                        <small class="c-field__message">
                            <i class="fa fa-info-circle"></i> All numbers are US based SMS/MMS enabled
                        </small>
                    </div>
                </div>

                <div class="col-4">
                    <div class="c-field">
                        <label class="c-field__label">Search</label>
                        <input v-model="form.query" class="c-input" type="text" maxlength="191" placeholder="Search by digits or phrases (Optional)">
                    </div>
                </div>

                <div v-if="form.context == 'contains'" class="col-4">
                    <div class="c-field">
                        <label class="c-field__label">Match To</label>
                        <v-select :value="matchOptions[0]" :clearable="false" :searchable="false" @update:model-value="matchToChanged" :options="matchOptions"></v-select>
                    </div>
                </div>
            </div>


            <div class="row u-mt-small">
                <div class="col-12">
                    <a href="#" class="pull-right u-ml-small c-btn c-btn--info" @click.prevent="search">
                        Search
                        <i v-if="formIsSubmitting" class="fa fa-spin fa-circle-o-notch"></i>
                    </a>

                    <a href="#" class="c-btn c-btn--secondary pull-right" @click.prevent="close">Done</a>
                </div>
            </div>

        </div><!-- eo c-card -->


        <div v-if="searchResultsCount == 0" class="u-mt-medium c-alert c-alert--warning alert">
            <i class="c-alert__icon fa fa-exclamation-circle"></i>
            No numbers were found that match your search criteria.
        </div>

        <div v-if="searchResults.length > 0" class="list">

            <table class="c-table resource-table u-mt-medium">
                <caption class="c-table__title">
                    <h1 class="pull-left">
                        Search Results <small>{{ searchResults.length }} Phone Numbers</small>
                    </h1>

                    <a v-if="showBulkBuy" @click.prevent="buySelected" class="pull-right c-btn c-btn--success" href="#">
                        Add Selected
                    </a>


                    <button v-if="bulkPurchasing.length > 0" class=" pull-right c-btn c-btn-success is-disabled">
                        Add Selected
                        <i class="fa fa-spin fa-circle-o-notch"></i>
                    </button>

                </caption>

                <thead class="c-table__head c-table__head--slim">
                    <tr class="c-table__row">

                        <th class="c-table__cell c-table__cell--head center hidden-xs">
                            <input v-model="selectAll" id="checkbox1" name="checkboxes" type="checkbox">
                        </th>
                        <th class="c-table__cell c-table__cell--head tag-cell">Number</th>
                        <th class="c-table__cell c-table__cell--head hidden-xs">Country Code</th>
                        <th class="c-table__cell c-table__cell--head hidden-xs">Region</th>
                        <th class="c-table__cell c-table__cell--head hidden-xs">Location</th>
                        <th class="c-table__cell c-table__cell--head hidden-xs">Postal Code</th>
                        <!-- <th class="c-table__cell c-table__cell--head center hidden-xs">Price</th> -->
                        <th class="c-table__cell c-table__cell--head center">Add</th>

                    </tr>
                </thead>

                <tbody>

                    <phone-number-search-result v-for="resource in searchResults" :phoneNumber="resource" :key="resource.phone_number"></phone-number-search-result>

                </tbody>
            </table><!-- // .c-table -->

        </div><!-- eo .list -->




    </div>
</template>

<script>
import VSelect from 'vue-select';
import { adminPhoneNumbersClient } from '../../services';
import PhoneNumberSearchResult from './PhoneNumberSearchResult.vue';

export default {
    components: {
        VSelect,
        PhoneNumberSearchResult,
    },

    props: ['phoneNumber'],

    data() {
        return {
            teamId: Spark.state.currentTeam.id,
            form: {
                context: null,
                country: 'US',
                query: null,
                vendor: 'twilio',
            },
            matchTo: null,
            formIsSubmitting: false,
            searchByOptions: [],
            matchOptions: [],
            countries: [],
            vendors: [
                {
                    id: 'twilio',
                    label: 'Twilio',
                    searchByOptions: [
                        { id: 'contains', label: 'Number' },
                        { id: 'location', label: 'Location' },
                        { id: 'areaCode', label: 'Area Code' },
                        { id: 'postalCode', label: 'Postal Code' },
                        { id: 'tollFree', label: 'Toll Free' },
                    ],
                    matchOptions: [
                        { id: 'any', label: 'Any part of number' },
                        { id: 'first', label: 'First part of number' },
                        { id: 'last', label: 'Last part of number '},
                    ],
                    countries: [
                        { id: 'US', label: 'United States'},
                        { id: 'CA', label: 'Canada'},
                    ],
                },
            ],
            searchResults: [],
            selectAll: false,
            bulkPurchasing: [],
        };
    },

    created() {
        Bus.$on('phone_numbersBuy', (number, vendor, country) => this.purchase(number, vendor, country));

        Bus.$on('phone_numbersPurchased', (number) => {
            this.bulkPurchasing = this.bulkPurchasing.filter((item) => item !== number);
        });

        this.$watch('selectAll', (newVal) => this.toggleAllSearchResults(newVal));

        this.form.vendor = this.vendors[0].id;
        this.searchByOptions =  this.vendors[0].searchByOptions;
        this.matchOptions =  this.vendors[0].matchOptions;
        this.countries =  this.vendors[0].countries;
    },

    computed: {
        showBulkBuy() {
            return this.bulkPurchasing.length == 0
                && this.searchResults.filter(e => e.selected == true).length > 1;
        },
        searchResultsCount() {
            return this.searchResults.length;
        },
    },

    methods: {
        buySelected() {
            this.searchResults.forEach((num) => {
                if(num.selected){
                    Bus.$emit(`phone_numbersBuying-${num.phone_number}`);
                    this.bulkPurchasing.push(num.phone_number);
                    this.purchase(num.phone_number, num.vendor);
                }
            });
        },

        toggleAllSearchResults(checked) {
            this.searchResults.forEach((result) => {
                result.selected = checked;
            });
        },

        search() {
            this.formIsSubmitting = true;
            let leftPad = (s, c, n) => c.repeat(n - s.length) + s; //leftPad('foo', '*', 5);
            let rightPad = (s, c, n) => s + c.repeat(n - s.length);

            let payload = JSON.parse(JSON.stringify(this.form));

            if (payload.context === 'tollFree') {
                payload.area_code = 833;
            }

            if (payload.query) {
                if (this.matchTo == 'first') {
                    payload.query = rightPad(payload.query, '*', 10);
                } else if (this.matchTo == 'last') {
                    payload.query = leftPad(payload.query, '*', 10);
                }
            }

            adminPhoneNumbersClient.search(this.teamId, payload)
                .then(({ data }) => {
                    //add selected attr for chk box
                    this.searchResults = data.map(el => ({ ...el, selected: false }));
                })
                .catch (() => {
                    this.$toasted.global.platform_error();
                })
                .finally(() => {
                    this.formIsSubmitting = false;
                });
        },


        purchase(number, vendor, country) {
            adminPhoneNumbersClient.create(this.teamId, { phone_number: number, vendor, country })
                .then(response => {

                    Bus.$emit(`phone_numbersPurchased`, response.data.phone_number);
                    Bus.$emit(`phone_numbersPurchased-${response.data.phone_number}`);
                    Bus.$emit(`phone_numbersCreated`, response.data);

                })
                .catch (error => {

                    let msg = '';

                    for(const [, value] of Object.entries(error.response.data.errors)){
                        msg += value.join(', ');
                    }
                    Bus.$emit(`phone_numbersPurchased`, number); //debit bulkPurchase queue
                    Bus.$emit(`phone_numbersPurchaseError-${number}`, msg);

                });
        },


        close(){
            Bus.$emit('phone_numbersCancelNew', this.phoneNumber.id);
        },


        searchByChanged(val){
            if(val == null) return;

            this.form.context = val.id;
            if(val.id != 'contains'){
                this.matchTo = null;
            }
        },


        matchToChanged(val){
            if(val == null) return;

            this.matchTo = val.id;
        },


        countryChanged(val){
            if(val == null) return;

            this.form.country = val.id;
        },

        vendorChanged(val){
            if(val == null) return;

            this.form.vendor = val.id;
            this.searchByOptions = val.searchByOptions;
            this.matchOptions = val.matchOptions;
            this.countries = val.countries;
        },
    },
};
</script>
